const VisionCard = ({ icon, header, text }) => {
  return (
    <div className="bg-white flex flex-col justify-start pt-20 items-center text-center shadow-lg  h-[300px] p-8 rounded-lg space-y-4">
      {icon}
      <h2 className="font-bold text-[20px]">{header}</h2>
      <p className="text-mainGray ">{text}</p>
    </div>
  );
};

export default VisionCard;
